import { useQuery } from '@tanstack/react-query';
import { getSignupConfig } from '@api/auth';
import type { SignupConfig } from '@api/types/auth';

const SIGNUP_CONFIG_QUERY_KEY = ['signup-config'] as const;

export interface UseSignupConfigResult {
  config: SignupConfig | undefined;
  signupBlocked: boolean;
  requiredDomain: string | null;
  isLoading: boolean;
}

export function useSignupConfig(): UseSignupConfigResult {
  const { data, isLoading } = useQuery({
    queryKey: SIGNUP_CONFIG_QUERY_KEY,
    queryFn: getSignupConfig,
    staleTime: 5 * 60_000,
  });

  return {
    config: data,
    signupBlocked: data?.signupBlocked ?? false,
    requiredDomain: data?.restricted && data.emailDomain ? data.emailDomain : null,
    isLoading,
  };
}

export default useSignupConfig;
